import type { DiagnosticTaskEntity } from '@/core/infrastructure/schemas/dashboard/ClassroomDiagnosticResultsSchema'

/**
 * Classe représentant une tâche de diagnostic
 */
export class ClassroomDiagnosticTask {
  readonly taskId: number
  readonly taskTitle: string
  readonly taskOrder: number
  readonly diagScorePercentRounded: number | null
  readonly diagEvalRangeName: string | null
  readonly diagEndScorePercentRounded: number | null
  readonly diagEndEvalRangeName: string | null

  constructor(data: DiagnosticTaskEntity) {
    this.taskId = data.taskId
    this.taskTitle = data.taskTitle
    this.taskOrder = data.taskOrder
    this.diagScorePercentRounded = data.diagScorePercentRounded
    this.diagEvalRangeName = data.diagEvalRangeName
    this.diagEndScorePercentRounded = data.diagEndScorePercentRounded
    this.diagEndEvalRangeName = data.diagEndEvalRangeName
  }

  /**
   * Vérifie si l'étudiant a commencé le diagnostic
   */
  public hasStartedDiagnostic(): boolean {
    return this.diagScorePercentRounded !== null
  }

  /**
   * Vérifie si l'étudiant a terminé le diagnostic de fin
   */
  public hasCompletedEndDiagnostic(): boolean {
    return this.diagEndScorePercentRounded !== null
  }

  /**
   * Calcule la progression entre diagnostic début et fin
   */
  public getDiagnosticProgression(): number | null {
    if (!this.hasStartedDiagnostic() || !this.hasCompletedEndDiagnostic()) return null
    return (this.diagEndScorePercentRounded || 0) - (this.diagScorePercentRounded || 0)
  }

  /**
   * Crée une instance à partir de données brutes
   */
  public static create(data: unknown): ClassroomDiagnosticTask {
    if (!data || typeof data !== 'object') {
      throw new Error('Invalid data for ClassroomDiagnosticTask')
    }

    const taskData = data as DiagnosticTaskEntity
    return new ClassroomDiagnosticTask(taskData)
  }
}
